import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { Box, Button, Card, CardContent, IconButton, Typography } from "@mui/material";
import EditIcon from "@material-ui/icons/Edit";
import ChatForm from "../../../ui_library/ver_24.10/ChatForm/ChatForm.comp";

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '80vh',
        width: '100%',
        padding: '20px',
        justifyContent: 'flex-start',
    },
    title: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        fontWeight: 'bold',
        fontSize: '40px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '32px',
        },
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        marginBottom: '20px',
        textAlign: 'center',
        position: 'sticky',
        top: '0',
        backgroundColor: '#ffffff',
        zIndex: 10,
        padding: '10px 0',
        width: '100%',
    },
    chatWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        maxWidth: '950px',
        height: '75vh',
        padding: '10px',
        borderRadius: '15px',
        backgroundColor: '#eeeeeeff',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
        overflowY: 'auto',
        overflowX: 'hidden',
    },
    chatContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        width: '100%',
        flexGrow: 1,
    },
    chatBubble: {
        padding: '5px 15px',
        borderRadius: '12px',
        maxWidth: '75%',
        fontSize: '16px',
    },
    botChat: {
        backgroundColor: '#fce5cd !important',
        alignSelf: 'flex-end',
        textAlign: 'left',
    },
    userChat: {
        display: 'flex',
        backgroundColor: '#f4cccc !important',
        alignSelf: 'flex-start',
        textAlign: 'left',
    },
    optionsContainer: {
        display: 'flex',
        justifyContent: 'center',
        gap: '10px',
        marginTop: '15px',
    },
    optionButton: {
        fontSize: '14px',
        textTransform: 'none',
        backgroundColor: '#EE6628 !important',
    },
    editContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
        marginTop: '5px',
        height:'45px',
    },
    editIcon: {
        marginLeft: '10px',
        cursor: 'pointer',
        color: '#EE6628 !important',
    },
}));

const FrameworkCreation = ({ data, options, actions }) => {
    const classes = useStyles();
    const { optionClickAction, restartChatFromIndexAction, inputSubmitAction, fileUploadAction } = actions;
    const { chats } = data;
    const chatEndRef = useRef(null);

   // Auto-scroll to the latest message
    useEffect(() => {
        if (chatEndRef.current) {
            chatEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [chats]);

    const handleOptionClick = (option) => {
        optionClickAction(option);
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            fileUploadAction(file);
        }
    };

    const handleEditClick = (index) => {
        restartChatFromIndexAction(index);
    };

    return (
        <Box className={classes.container}>
            <h1 className={classes.title}>
                Welcome to the Digital Intelligence Framework Builder.
            </h1>
            <Box className={classes.chatWrapper}>
                <Box className={classes.chatContainer}>
                    {chats.map((chat, index) => (
                        <Card
                            key={index}
                            className={`${classes.chatBubble} ${chat.role === "bot" ? classes.botChat : classes.userChat}`}
                        >
                            <CardContent>
                                <Typography style={{ whiteSpace: "pre-line" }}>
                                    {chat.text}
                                </Typography>
                            </CardContent>
                            {chat.role === "user" && (
                                <Box className={classes.editContainer}>
                                    <IconButton className={classes.editIcon} onClick={() => handleEditClick(index)}>
                                        <EditIcon />
                                    </IconButton>
                                </Box>
                            )}
                        </Card>
                    ))}

                    {chats.length > 0 && chats[chats.length - 1].role === "bot" && chats[chats.length - 1].options && (
                        <Box className={classes.optionsContainer}>
                            {chats[chats.length - 1].options.map((option, idx) => (
                                <Button
                                    key={idx}
                                    variant="contained"
                                    className={classes.optionButton}
                                    onClick={() => handleOptionClick(option)}
                                >
                                    {option}
                                </Button>
                            ))}
                        </Box>
                    )}

                    {chats.type === "file_upload" && (
                        <Box mt={2}>
                            <input
                                type="file"
                                id="upload-file"
                                accept=".pdf,.docx,.txt"
                                style={{ display: "none" }}
                                onChange={handleFileUpload}
                            />
                            <label htmlFor="upload-file">
                                <Button variant="contained" component="span" color="primary">
                                    Upload File
                                </Button>
                            </label>
                        </Box>
                    )}

                    {chats.length > 0 && chats[chats.length - 1].role === "bot" && chats[chats.length - 1].type === "form" && (
                        <Card className={`${classes.chatBubble} ${classes.botChat}`} style={{ width: "fit-content", maxWidth: "80%" }}>
                            <CardContent>
                                <ChatForm fields={chats[chats.length - 1].fields} onSubmit={inputSubmitAction} />
                            </CardContent>
                        </Card>
                    )}

                    {/* Auto-scroll target */}
                    <div ref={chatEndRef}></div>
                </Box>
            </Box>
        </Box>
    );
};

export default FrameworkCreation;
